import { Col, Row } from "react-bootstrap";
import { TextFit } from "../../../../component-library";
import {
    TIFInitialGradingNoProcedure,
    TIFPostProcedureGrading,
    TIFInitialGradingWithProcedure,
    TIFScleraGrading,
} from ".";
import { isSclera } from "../../../../models";
import { useTIFFormData } from "../../../../hooks";
import { useMemo } from "react";
import { TissueInformationFormProps } from "./TissueInformationForm";

export function TIFGrading({ tissueId }: Readonly<TissueInformationFormProps>) {
    const { hasInitialGrading, hasPostProcedureGrading, tissue } = useTIFFormData({ tissueId });

    const content = useMemo(() => {
        if (isSclera(tissue?.tissueType?.name)) {
            return <TIFScleraGrading tissueId={tissueId} />;
        }

        return (
            <>
                {hasInitialGrading && hasPostProcedureGrading && (
                    <Col md={4}>
                        <TIFInitialGradingWithProcedure tissueId={tissueId} />
                    </Col>
                )}
                {hasInitialGrading && !hasPostProcedureGrading && (
                    <Col>
                        <TIFInitialGradingNoProcedure tissueId={tissueId} />
                    </Col>
                )}
                {hasPostProcedureGrading && (
                    <Col md={hasInitialGrading ? 8 : 12}>
                        <TIFPostProcedureGrading tissueId={tissueId} />
                    </Col>
                )}
            </>
        );
    }, [hasInitialGrading, hasPostProcedureGrading, tissue?.tissueType?.name, tissueId]);

    return (
        <>
            <TextFit style={{ maxHeight: "330px" }} maxFontSizePx={12}>
                <Row>{content}</Row>
            </TextFit>
            <hr className="my-1" />
        </>
    );
}
